/** 救援推送页常量（保持与原 RescuePush.js 一致） */

/** 5 分钟内为在线 */
export const ONLINE_TIMEOUT = 5 * 60 * 1000;

export const STORAGE_KEYS = {
  targets: 'rescue_push_targets',
  tracks: 'rescue_push_tracks'
};

export const ICONS = [
  { value: 'flag', label: '旗帜' },
  { value: 'pin', label: '图钉' },
  { value: 'star', label: '星标' },
  { value: 'sos', label: 'SOS' },
  { value: 'person', label: '人员' },
  { value: 'custom', label: '自定义' }
];

export const TRACK_PREVIEW_ID = 'track-preview';

export const DEFAULT_TARGET_FORM = {
  org_names: [],
  group_names: [],
  user_names: [],
  lat: '',
  lng: '',
  icon: '旗帜',
  message: '',
  map_link: '',
  level: '普通',
  to_all: false,
  expires_at: '',
  mission_id: '',
  mission_group_id: '',
  mission_group_name: ''
};

export const DEFAULT_TRACK_FORM = {
  org_names: [],
  group_names: [],
  user_names: [],
  message: '',
  icon: '旗帜',
  to_all: false
};


/** 本地时区 datetime-local 值（YYYY-MM-DDTHH:mm） */
export function toDatetimeLocalValue(date = new Date()) {
  const d = date instanceof Date ? date : new Date(date);
  if (Number.isNaN(d.getTime())) return '';
  const pad = (n) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

/** 默认有效时间：当前 + 24 小时（本地输入框） */
export function defaultExpiresAtLocalInput(fromDate = new Date()) {
  const base = fromDate instanceof Date ? fromDate : new Date(fromDate);
  return toDatetimeLocalValue(new Date(base.getTime() + 24 * 60 * 60 * 1000));
}

/** datetime-local → ISO（按浏览器本地时区解释） */
export function datetimeLocalToIso(value) {
  if (!value) return null;
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return null;
  return d.toISOString();
}

/** 是否已过有效期（无 expires_at 视为不过期，兼容旧数据） */
export function isRescueTargetExpired(item, now = Date.now()) {
  if (!item || item.expires_at == null || item.expires_at === '') return false;
  const t = new Date(item.expires_at).getTime();
  return Number.isFinite(t) && t <= now;
}
